var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language",class:{ active: _vm.isSelected }},[_c('div',{staticClass:"name-flag"},[_c('img',{staticClass:"flag",attrs:{"src":_vm.imageUrl,"alt":_vm.name + 'Flag'}}),_c('span',{staticClass:"lang-name"},[_vm._v(_vm._s(_vm.name))])]),_c('ToggleSwitch',{attrs:{"code":_vm.code},on:{"switchChecked":_vm.setIsSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }